import mixins from 'synergycms_core/src/less/mixins';

export default {
  pointerStyle: {
    ...mixins.transform('rotate(45deg)'),
    position: 'absolute',
    zIndex: 900
  }
};
